import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./custom-modal-v1.css";

interface Props {
  isOpen: boolean;
  children: React.ReactNode;
  handleClose?: () => void;
  className?: string;
  closeOnBackdrop?: boolean;
}

function CustomModalV1({
  isOpen,
  children,
  handleClose,
  className = "",
  closeOnBackdrop = false,
}: Props) {
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="v1-modal-overlay"
      onClick={closeOnBackdrop ? handleClose : undefined}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`v1-modal-box${className ? ` ${className}` : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}

export default CustomModalV1;
